import { useState } from "react";

const useCellTab = (width: number, height: number) => {
  const [selectedCell, setSelectedCell] = useState<{
    row: number;
    column: number;
  }>({ row: -1, column: -1 });

  const setNextCell = (row: number, column: number) => () => {
    // always set row to -1 as non value
    if (row === -1) {
      setSelectedCell({ row, column });
    }
    // check if column + 1 is out of bounds and row is not out of bounds
    else if (column + 1 >= width && row + 1 < height) {
      setSelectedCell({ row: row + 1, column: 0 });
    }
    // if column is in bounds, advance to next column
    else if (column + 1 < width) {
      setSelectedCell({ row, column: column + 1 });
    }
  };
  return { selectedCell, setNextCell, setSelectedCell };
};

export default useCellTab;
